import { loadScriptAsync } from '@/utils/window';
import { apiUrl } from './constants';

export const initGoogleMapsAPI = () => loadScriptAsync(apiUrl);
